import { render } from "./PRNAdminModal.vue?vue&type=template&id=7a50c607"
import script from "./PRNAdminModal.vue?vue&type=script&lang=js"
export * from "./PRNAdminModal.vue?vue&type=script&lang=js"

import "./PRNAdminModal.vue?vue&type=style&index=0&id=7a50c607&lang=scss"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__